export default "__VITE_ASSET__BU7CR4Ld__"